import { useEffect, useState } from 'react';

import { Guide } from '../types';
import { fetchGuide } from '../services/designThinkingService';

export const useGuide = () => {
  const [guide, setGuide] = useState<Guide[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadGuide = async () => {
      try {
        setLoading(true);
        const data = await fetchGuide();
        if (isMounted) {
          setGuide(data);
          setError(null);
        }
      } catch (error) {
        if (isMounted) {
          setError(error instanceof Error ? error.message : 'Unknown error occurred');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadGuide();

    return () => {
      isMounted = false;
    };
  }, []);

  return { guide, loading, error };
};
